export const generateRandomId = () => {
  const randomNum = Math.random().toString();
  const randomId = `id_${randomNum.substring(2, 10)}`;

  return randomId;
};
